import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './app/App.js'
import './styles/global.css'

createRoot(document.getElementById('app')!).render(
  <StrictMode><App /></StrictMode>,
)